import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort, MatSortHeader} from '@angular/material/sort';
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatTable,
    MatTableDataSource
} from '@angular/material/table';
import {BreadCrumb} from '../../models/breadcrumb';
import {MatCard, MatCardContent, MatCardHeader, MatCardSubtitle, MatCardTitle} from '@angular/material/card';
import {RouterLink} from '@angular/router';
import {MatInput} from '@angular/material/input';
import {MatFormField} from '@angular/material/form-field';
import {MatButton, MatMiniFabButton} from '@angular/material/button';
import {MatTooltip} from '@angular/material/tooltip';
import {BreadcrumbsComponent} from '../breadcrumbs/breadcrumbs.component';
import {ProgressComponent} from '../progress/progress.component';
import {I18nPluralPipe} from '@angular/common';
import {collection, collectionData, DocumentData, Firestore, orderBy, query} from '@angular/fire/firestore';
import {Auth, authState} from '@angular/fire/auth';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-admin-accounts',
    templateUrl: './accounts.component.html',
    styleUrls: ['./accounts.component.css'],
    imports: [
        MatCard,
        MatCardTitle,
        MatCardSubtitle,
        MatCardHeader,
        RouterLink,
        MatFormField,
        MatInput,
        MatTable,
        MatCardContent,
        MatSort,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCell,
        MatCellDef,
        MatTooltip,
        MatMiniFabButton,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        MatSortHeader,
        MatPaginator,
        BreadcrumbsComponent,
        ProgressComponent,
        I18nPluralPipe,
        MatButton
    ],
    standalone: true
})
export class AccountsComponent implements OnInit, AfterViewInit, OnDestroy {

    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
    @ViewChild(MatSort, {static: true}) sort: MatSort;
    dataSource: MatTableDataSource<DocumentData>;
    displayedColumns: string[] = ['name', 'actions'];
    breadcrumbs: BreadCrumb[];
    accountPluralMapping = {
        '=0': '0 Accounts',
        '=1': '1 Account',
        other: '# Accounts'
    };
    admin: boolean;
    private subscription: Subscription;
    private authSubscription: Subscription;

    constructor(private firestore: Firestore, private fireAuth: Auth) {
    }

    ngOnInit() {
        this.authSubscription = authState(this.fireAuth).subscribe(async (value) => {
            const result = await value.getIdTokenResult();
            this.admin = Boolean(result.claims.admin);
        });
        this.breadcrumbs = [
            {url: null, title: 'Accounts'},
        ];
        const accountsColRef = collection(this.firestore, 'accounts');
        const accountsQuery = query(accountsColRef, orderBy('name', 'asc'));

        this.subscription = collectionData(accountsQuery, {idField: 'id'})
            .subscribe(data => {
                    this.dataSource = new MatTableDataSource(data);
                    this.dataSource.sort = this.sort;
                    this.dataSource.paginator = this.paginator;
                }
            );
    }

    ngAfterViewInit() {
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
        this.authSubscription.unsubscribe();
    }

    search(event: any) {
        this.dataSource.filter = event.target.value.trim().toLowerCase();
    }

}
